import React, { useState } from 'react';
import "./index.scss";
import SubmitFeedbackToVendorModal from 'components/common/SubmitFeedbackToVendorModal';
import { useParams } from 'react-router-dom';

const OrderFeedbackPage = () => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const { orderId } = useParams();

  return (
    <>
      <div className="container-fluid order-feedback">
        <div className="hero">
          <div className="alert-icon">🍽️</div>
          <h1>How was your order?</h1>
          <p className="lead">
            We’d love to hear how everything went with your recent delivery.
            Your feedback helps us improve future experiences.
          </p>
          <div className="actions">
            <button
              className="btn-primary"
              type="button"
              onClick={() => setShowFeedbackModal(true)}
            >
              💬 Submit feedback to vendor
            </button>
          </div>
        </div>
      </div>

      <SubmitFeedbackToVendorModal
        show={showFeedbackModal}
        onClose={() => setShowFeedbackModal(false)}
        orderId={orderId}
      />
    </>
  );
};

export default OrderFeedbackPage;
